<!-- 患者画像 -->
<template>
  <div class="patient-portrait">
    <div class="portrait-header">
      <span class="title">患者画像</span>
    </div>
    <div class="portrait-body">
      <div class="info-item">
        <span class="label">复诊情况：</span>
        <span class="value">{{ followUpCountLabel || '--' }}</span>
      </div>
      <div class="info-item">
        <span class="label">依从性：</span>
        <span class="value">{{ compliance || '--' }}</span>
      </div>
      <div class="info-item risk-item">
        <span class="label">关键风险：</span>
        <span class="value" :style="!portraitData.keyRiskLabel ? { color: '#000000' } : {}">
          {{ risk || '--' }}
        </span>
        <!-- <a-tag v-if="showRiskTag" color="red" class="risk-tag">
          紧急
        </a-tag> -->
      </div>
      <div class="info-item todo-item">
        <span class="label">近期待办：</span>
        <span class="value" :style="!portraitData.todoItems ? { color: '#000000' } : {}">
          {{ todo || '--' }}
        </span>
        <a-tag v-if="showTodoTag" class="todo-tag">待处理</a-tag>
      </div>
      <div class="action-right">
        <a-button type="link" class="view-btn" @click="handleOpenModal">
          查看患者画像
          <RightOutlined />
        </a-button>
      </div>
    </div>
    <PatientPortraitModal
      v-model:visible="modalVisible"
      :uc-doctor-id="ucDoctorId"
      :uc-patient-id="ucPatientId"
    />
  </div>
</template>

<script setup>
import { computed, defineProps, ref, watch } from 'vue'
import { RightOutlined } from '@ant-design/icons-vue'
import PatientPortraitModal from '@/components/PatientPortraitModal/index.vue'
import { getPatientPortraitDetail } from '@/api/patientFile'

const props = defineProps({
  ucDoctorId: {
    type: [String, Number],
    default: ''
  },
  ucPatientId: {
    type: [String, Number],
    default: ''
  }
})

const portraitData = ref({})

const toDisplayValue = (value, fallback = '--') => {
  return value === undefined || value === null || value === '' ? fallback : value
}

const followUpCountLabel = computed(() => {
  const stage = portraitData.value?.followUpCountLabel || portraitData.value?.followUpCountLabel
  return toDisplayValue(stage)
})

const compliance = computed(() => {
  const complianceValue =
    portraitData.value?.currentStatusMedicationAdherenceLabel ||
    portraitData.value?.currentStatusMedicationAdherenceValue
  return toDisplayValue(complianceValue)
})

const risk = computed(() => {
  return portraitData.value.keyRiskLabel || '--'
})

const showRiskTag = computed(() => risk.value && risk.value !== '--')

const todo = computed(() => {
  return toDisplayValue(portraitData.value?.todoItems)
})

const showTodoTag = computed(() => todo.value && todo.value !== '--')

const modalVisible = ref(false)

const handleOpenModal = () => {
  modalVisible.value = true
}

const loadPortraitData = async () => {
  const ucDoctorId = props.ucDoctorId
  const ucPatientId = props.ucPatientId
  if (!ucDoctorId || !ucPatientId) {
    portraitData.value = {}
    return
  }
  try {
    const detail = await getPatientPortraitDetail({
      ucDoctorId,
      ucPatientId
    })
    portraitData.value = detail || {}
  } catch (error) {
    portraitData.value = {}
  }
}

watch(
  () => [props.ucDoctorId, props.ucPatientId],
  () => {
    loadPortraitData()
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
.patient-portrait {
  .portrait-header {
    margin-bottom: 12px;

    .title {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }
  }

  .portrait-body {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 24px 62px;
    padding: 12px 16px;
    background: #fafafa;
    border-radius: 4px;

    .info-item {
      display: flex;
      align-items: center;
      gap: 4px;
      flex-shrink: 0;

      .label {
        position: relative;
        display: inline-block;
        padding-left: 20px;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        color: #999999;
        flex-shrink: 0;

        &::before {
          content: '·';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-60%);
          color: #014ea8;
          font-size: 40px;
          line-height: 1;
        }
      }

      .value {
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        color: #333333;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &.risk-item {
        align-items: center;
        .value {
          color: #fc8801;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
        }
        .risk-tag {
          margin: 0;
          padding: 0 6px;
          font-size: 12px;
          line-height: 20px;
        }
      }

      &.todo-item {
        align-items: center;
        flex: 1;
        min-width: 0;
        .value {
          color: #02c5a2;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          max-width: unset;
          flex: 0 1 auto;
          min-width: 0;
        }
        .todo-tag {
          margin: 0;
          padding: 0 6px;
          font-size: 12px;
          line-height: 20px;
          flex-shrink: 0;
        }
        ::v-deep(.ant-tag) {
          color: #02c5a2;
          border-radius: 4px;
          border: 1px solid #02c5a2;
          background: #02c5a21a;
        }
      }
    }

    .action-right {
      margin-left: auto;
      flex-shrink: 0;

      .view-btn {
        padding: 0;
        color: #014ea8;
        font-size: 16px;

        &:hover {
          color: #014ea8;
        }
      }
    }
  }
}
</style>
